import React from 'react';
import './Heading.css';

/**
 * Reusable Heading component that applies consistent styling across pages.
 * @param {Object} props
 * @param {string} props.title - The text to display in the heading
 * @param {string} props.level - 'h1', 'h2', 'h3', 'h4', 'h5', 'h6' (defaults to 'h2')
 * @param {string} props.className - Additional custom class names
 */
const Heading = ({ title, level = 'h2', className = '' }) => {
  const Tag = level;
  
  return (
    <Tag className={`res-page-heading ${className}`}>
      {title}
    </Tag>
  );
};

export default Heading;
